// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper__1O5TA","title":"style_title__2k6Ir"};